import { useDisclosure } from '@chakra-ui/react';
import { CallToolController, CallToolLoader } from './callPartInterface';
import { CallToolContainerProps } from './callPartProps';
import { useState } from 'react';
import { assert, assertNever } from '@varos/util-typescript';
import { ContextItem, MessagePart } from '@varos/assistant-sdk';
import { ChatContainerBaseConfig } from '../../base';

export function createCallToolContainer(
    config: ChatContainerBaseConfig,
    loader: CallToolLoader,
    controller: CallToolController
): React.FC<CallToolContainerProps> {
    const {
        repository: { assistant: repository },
        context: { useContext },
        context: {
            thread: { useContext: useThreadContext },
        },
    } = config;
    return ({ as: View, ...containerProps }) => {
        const context = useContext();

        const mutation = {
            message: repository.local.message.useUpdate(context),
        };

        const item = loader.useLoad(context, containerProps);

        const { chat } = useThreadContext();
        const disclosure = useDisclosure();

        function onAccept() {
            disclosure.onOpen();
        }

        const props = controller.useProps(context, item, {
            disclosure,
            onAccept,
            async onReject() {
                const response = await mutation.message.mutateAsync({
                    id: item.message.id,
                    parts: item.message.parts.map((part): MessagePart => {
                        if (
                            part.type === 'tool-invocation' &&
                            part.toolInvocation.callId === item.tool.callId &&
                            part.toolInvocation.toolName === 'start_call'
                        ) {
                            return {
                                ...part,
                                toolInvocation: {
                                    ...part.toolInvocation,
                                    state: 'result',
                                    result: {
                                        status: {
                                            kind: 'rejected',
                                        },
                                    },
                                },
                            };
                        }
                        return part;
                    }),
                });
            },
            async onTimeout() {
                const response = await mutation.message.mutateAsync({
                    id: item.message.id,
                    parts: item.message.parts.map((part): MessagePart => {
                        if (
                            part.type === 'tool-invocation' &&
                            part.toolInvocation.callId === item.tool.callId &&
                            part.toolInvocation.toolName === 'start_call'
                        ) {
                            return {
                                ...part,
                                toolInvocation: {
                                    ...part.toolInvocation,
                                    state: 'result',
                                    result: {
                                        status: {
                                            kind: 'timeout',
                                        },
                                    },
                                },
                            };
                        }
                        return part;
                    }),
                });
            },
            async onEnd(call) {
                console.log('onEnd triggered call part', {
                    callId: item.tool.callId,
                    call,
                });
                assert(item.tool.callId, 'callId is required');

                const context = item.thread.context.map((item): ContextItem => {
                    if (item.kind === 'solution') {
                        return {
                            kind: 'solution',
                            data: {
                                solutionId: item.solutionId,
                            },
                        };
                    }
                    if (item.kind === 'integration') {
                        return {
                            kind: 'integration',
                            data: {
                                integrationId: item.integrationId,
                            },
                        };
                    }
                    throw new Error('unsupported context item');
                });

                // NOTE we rely on optimistic message updates and close call modal immediately
                const response = mutation.message.mutate({
                    id: item.message.id,
                    context,
                    parts: item.message.parts.map((part): MessagePart => {
                        if (
                            part.type === 'tool-invocation' &&
                            part.toolInvocation.callId === item.tool.callId &&
                            part.toolInvocation.toolName === 'start_call'
                        ) {
                            return {
                                ...part,
                                toolInvocation: {
                                    ...part.toolInvocation,
                                    state: 'result',
                                    result: {
                                        status: {
                                            kind: 'finished',
                                            duration_ms: call.durationMs,
                                            summary: call.summary,
                                            // transcript: {
                                            //     messages: [],
                                            //     // messages: call.transcript.messages.map(
                                            //     //     (item) => ({
                                            //     //         role: item.role,
                                            //     //         text: item.text,
                                            //     //     })
                                            //     // ),
                                            // },
                                        },
                                    },
                                },
                            };
                        }
                        return part;
                    }),
                });

                disclosure.onClose();

                // await chat.reload();

                console.log('generating reply for tool', response);

                await chat.reply({
                    context,
                    parts: [
                        {
                            type: 'text',
                            text: `CALL_FINISHED: ${JSON.stringify(call, null, 2)}`,
                        },
                    ],
                });

                containerProps;

                // await chat.reload();
                // await chat.reply({
                //     ...response,
                // });
            },
        });
        return <View {...props} />;
    };
}
